import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ProjectsPage, { ProjectPostPage } from "./pages/ProjectsPage";
import SellPanelsPage from "./pages/SellPanelsPage";
import BuyPanelsPage from "./pages/BuyPanelsPage";
import KoreaOperationsPage from "./pages/KoreaOperationsPage";
import CompliancePage from "./pages/CompliancePage";
import PanelsWeTradePage from "./pages/PanelsWeTradePage";
import ContactPage from "./pages/ContactPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import CorporatePartnersPage from "./pages/CorporatePartnersPage";
import AdminPage from "./pages/AdminPage";
import TradePortalPage from "./pages/TradePortalPage";
import NotFoundPage from "./pages/NotFoundPage";

// Layout
import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";
import LanguageWrapper from "./components/LanguageWrapper";
import LanguageRedirect from "./components/LanguageRedirect";

// Shared page routes, mounted once for the unprefixed English branch ("/")
// and once for the language-prefixed branch ("/:lang") — see LanguageWrapper.
const pageRoutes = (
  <>
    <Route index element={<HomePage />} />
    <Route path="about" element={<AboutPage />} />
    <Route path="projects" element={<ProjectsPage />} />
    <Route path="projects/:id" element={<ProjectPostPage />} />
    <Route path="sell-panels" element={<SellPanelsPage />} />
    <Route path="buy-panels" element={<BuyPanelsPage />} />
    <Route path="korea-operations" element={<KoreaOperationsPage />} />
    <Route path="compliance" element={<CompliancePage />} />
    <Route path="panels" element={<PanelsWeTradePage />} />
    <Route path="contact" element={<ContactPage />} />
    <Route path="privacy" element={<PrivacyPage />} />
    <Route path="terms" element={<TermsPage />} />
    <Route path="corporate-partners" element={<CorporatePartnersPage />} />
    <Route path="*" element={<NotFoundPage />} />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <LanguageRedirect />
        <Routes>
          <Route path="/" element={<LanguageWrapper />}>
            <Route element={<Layout />}>
              {pageRoutes}
            </Route>
          </Route>
          <Route path="/:lang" element={<LanguageWrapper />}>
            <Route element={<Layout />}>
              {pageRoutes}
            </Route>
          </Route>
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/portal" element={<TradePortalPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
